<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>工作日报</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form"
        @submit.native.prevent="getList()">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="员工" prop="userid">
          <el-select v-model="query.userid" placeholder="请选择" filterable clearable @change="selList()">
            <el-option v-for="item in userList" :label="item.realName" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间段" label-width="80px" style="margin-left: 8px">
          <el-date-picker v-model="query.daterange" @change="selList()" value-format="yyyy-MM-dd HH:ss:mm"
            type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="addClick()">新增</el-button>
          <el-button type="warning" @click="exportClick()">导出</el-button>
          <el-button type="danger" @click="exportWeekClick()">导出本周</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 主体 -->
    <div class="content">
      <el-card class="box-card table">
        <!-- 列表 -->
        <div>
          <div v-for="(item, index) in tableData" :key="item.id" :label="item.name" :vlaue="item.id">
            <div class="rowleft">
              <el-card class="box-card table">
                <div class="leftright">
                  <div>
                    <el-button style="
                        float: right;
                        padding: 0px;
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        text-align: center;
                        border-radius: 50%;
                      " type="danger" icon="el-icon-close" size="mini" @click="delClick(item.id)"
                      v-if="item.userName == info.nickName"></el-button>
                    <div class="left">
                      <div class="userimg">
                        <img :src="item.userPhoto" alt />
                      </div>
                    </div>
                    <div class="userinfo">
                      <div class="username">{{ item.userName }}</div>
                      <div class="date">{{ item.createTime }}</div>
                    </div>
                    <div class="clear"></div>
                  </div>
                  <div class="leftintrol">
                    <div class="summarize">
                      <div class="title">工作总结：</div>
                      <div class="namesplit">
                        <div class="name" v-for="item in item.summary.split('\n')" :label="item" :value="item"
                          :key="item">
                          {{ item }}
                        </div>
                      </div>
                    </div>
                    <div class="summarize">
                      <div class="title">工作计划：</div>
                      <div class="namesplit">
                        <div class="name" v-for="item in item.plan.split('\n')" :label="item" :value="item" :key="item">
                          {{ item }}
                        </div>
                      </div>
                    </div>
                    <div class="summarize" v-if="item.progress">
                      <div class="title">项目进度：</div>
                      <div class="namesplit">
                        <div class="name" v-for="item in item.progress.split('\n')" :label="item" :value="item"
                          :key="item">
                          {{ item }}
                        </div>
                      </div>
                    </div>
                    <div class="project" v-if="item.project">
                      <div class="name" v-for="item in item.project.split(',')" :label="item" :value="item" :key="item">
                        {{ item }}
                      </div>
                    </div>
                  </div>
                  <div class="clear"></div>
                </div>
              </el-card>
            </div>
            <div class="line" v-if="index % 3 == 2 || index == tableData.length - 1"></div>
          </div>
          <div class="blank" v-if="tableData.length == 0">暂无数据~~</div>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id > 0 ? '编辑日报' : '添加日报'" :visible.sync="dialogVisible">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <el-form-item label="工作时间" prop="createTime" :rules="[{ required: true, message: '不能为空' }]">
          <el-date-picker v-model="form.createTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
            placeholder="请选择添加时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="工作总结" prop="summary" :rules="[{ required: true, message: '不能为空' }]">
          <el-input type="textarea" v-model="form.summary" placeholder="请输入工作总结，使用换行隔开" :rows="4"></el-input>
        </el-form-item>
        <el-form-item label="工作计划" prop="plan" :rules="[{ required: true, message: '不能为空' }]">
          <el-input type="textarea" v-model="form.plan" placeholder="请输入工作计划，使用换行隔开" :rows="4"></el-input>
        </el-form-item>
        <el-form-item label="项目进度" prop="progress" :rules="[{ required: false, message: '不能为空' }]">
          <el-input type="textarea" v-model="form.progress" placeholder="请输入项目，使用换行隔开，组长必填" :rows="6"></el-input>
        </el-form-item>
        <el-form-item label="关联项目">
          <el-select v-model="projectlist" multiple placeholder="请选择项目" style="width: 100%">
            <el-option v-for="item in prolist" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="dialog-footer">
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
export default {
  data() {
    return {
      query: {
        userid: "",
        daterange: [],
      },
      form: {},
      tableData: [],
      dialogVisible: false,
      submiting: false,
      loading: false,
      typelist: [
        { id: "", name: "全部" },
        { id: 1, name: "自己" },
      ],
      prolist: [],
      projectlist: [],
      info: {},
      userList: [], //员工列表
    };
  },
  methods: {
    getUserInfo: function () {
      var _this = this;
      var info = user.getInfo();
      _this.info = info;
    },
    //   获取项目
    getProjectList: function () {
      var _this = this;
      var link = url.getProject("getlistall");
      $.get(link, {}, (data) => {
        _this.prolist = data;
      });

      //获取员工
      link = url.getUser("getemployee");
      $.get(link, {}, (data) => {
        _this.userList = data;
      });
    },
    //   列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var now = new Date();
      var startDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
      var endDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      );
      var today = now.toLocaleString();
      var start = startDate.toLocaleString();
      var end = endDate.toLocaleString();
      var params = Object.assign({}, this.query);
      if (_this.query.daterange) {
        params.start = _this.query.daterange[0].toLocaleString();
        params.end = _this.query.daterange[1].toLocaleString();
      } else {
        params.start = start;
        params.end = end;
      }
      var link = url.getCdn("getpaper");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data;
      });
    },
    // 查询
    selList: function () {
      this.getList();
    },
    // 添加
    addClick: function () {
      this.dialogVisible = true;
      var now = new Date();
      this.projectlist = [];
      this.form = {
        createTime: now,
      };
    },
    // 导出
    exportClick: function () {
      var _this = this;
      var params = Object.assign({}, this.query);
      //日期选择处理
      if (_this.query.daterange) {
        params.start = _this.query.daterange[0].toLocaleString();
        params.end = _this.query.daterange[1].toLocaleString();
      } else {
        params.start = start;
        params.end = end;
      }
      var result = [];
      for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
      var link = url.getCdn("exportpaper") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    // 导出本周
    exportWeekClick: function () {
      var _this = this;
      var now = new Date();
      var week = now.getDay();
      if (week == 0) {
        var startDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() - 6
        );
        var endDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() - week + 1
        );
      } else {
        var startDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() - week + 1
        );
        var endDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() - week + 8
        );
      }
      var start = startDate.toLocaleString();
      var end = endDate.toLocaleString();

      var params = _this.query;
      params.start = start;
      params.end = end;

      var result = [];
      for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
      var link = url.getCdn("exportpaper") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    // 删除
    delClick: function (id) {
      var _this = this;
      var link = url.getCdn("deletepaper");
      var id = id;

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            _this.loading = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 提交
    submitForm: function (formName) {
      var _this = this;
      var link = url.getCdn("addpaper");
      var info = this.form;

      info.project = this.projectlist.join();
      info.createTime = info.createTime.toLocaleString();

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    var now = new Date();
    var startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var endDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1
    );
    var start = new Date(startDate);
    var end = new Date(endDate);
    this.query.daterange = [start, end];
    // 登陆人
    this.getUserInfo();
    //   项目
    this.getProjectList();
    //列表
    this.getList();
  },
};
</script>